export const MAX_PICTURE_BYTES = 10 * 1024 * 1024;

export interface DraftPoint {
  x: number;
  y: number;
}

export interface DraftStroke {
  kind: 'mark' | 'cover';
  points: DraftPoint[];
}

/** A dragged mark or cover is the two corners of one rectangle. A click is not a rectangle. */
export function rectangleStroke(
  kind: 'mark' | 'cover',
  start: DraftPoint,
  end: DraftPoint,
): DraftStroke | null {
  if (start.x === end.x && start.y === end.y) {
    return null;
  }
  return {
    kind,
    points: [
      { x: start.x, y: start.y },
      { x: end.x, y: end.y },
    ],
  };
}
